import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AppShell } from "../components/AppShell";
import { API } from "../lib/apiClient";

// Sara Connor trading page — deux vues dans le même dashboard :
//  • Terminal Crypto (public/trading-crypto.html) — exchange crypto fidèle à "Image 2"
//  • Manager Pro / Bot IA (public/trading-desk.html) — modules institutionnels (bot, positions,
//    journal, Top 5 signaux IA, risk control, capital manager, comité Claude, corrélation,
//    calendrier macro, backtesting). Données réelles Binance, trading papier.
const VIEWS = [
  { id: "crypto", label: "Terminal Crypto", file: "trading-crypto.html" },
  { id: "pro", label: "Manager Pro — Bot IA", file: "trading-desk.html" },
];

export default function Trading() {
  const navigate = useNavigate();
  const iframeRef = useRef(null);
  const [view, setView] = useState("crypto");
  const [proHeight, setProHeight] = useState(0);

  // Le desk Pro (trading-desk.html) poste sa hauteur réelle → on auto-dimensionne l'iframe
  // pour éviter le scroll imbriqué (la page parente scrolle naturellement).
  useEffect(() => {
    const onMsg = (e) => {
      const h = e?.data?.__saraDeskHeight;
      if (typeof h === "number" && h > 400) setProHeight(h);
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);

  const current = VIEWS.find((v) => v.id === view) || VIEWS[0];
  const isPro = view === "pro";
  const iframeHeight =
    isPro && proHeight ? `${proHeight}px` : "calc(100vh - 150px)";

  return (
    <AppShell
      title="Trading"
      subtitle="Terminal crypto IA + Manager Pro — Sara Connor · trading papier, données réelles Binance"
      wide
    >
      {/* Sélecteur de vue */}
      <div
        data-testid="trading-view-switcher"
        className="mb-3 flex flex-wrap items-center gap-2"
      >
        {VIEWS.map((v) => (
          <button
            key={v.id}
            data-testid={`trading-view-${v.id}`}
            onClick={() => {
              setView(v.id);
              setProHeight(0);
            }}
            className={`rounded-full px-4 py-2 text-[13px] font-semibold transition-colors border ${
              view === v.id
                ? "bg-[rgba(56,189,248,0.14)] border-[var(--border-hud)] text-white shadow-[0_0_16px_-6px_rgba(56,189,248,0.7)]"
                : "bg-black/40 border-white/10 text-white/60 hover:text-white hover:bg-white/5"
            }`}
          >
            {v.label}
          </button>
        ))}
      </div>

      <div
        data-testid="trading-page"
        className="relative clip-corner overflow-hidden border border-[var(--border-hud)] bg-black"
      >
        <iframe
          key={view}
          ref={iframeRef}
          title="Sara Connor — Trading Dashboard"
          src={`/${current.file}?api=${encodeURIComponent(API)}`}
          data-testid="trading-iframe"
          className="w-full border-0 block"
          style={{ height: iframeHeight, minHeight: 640 }}
        />
        <button
          data-testid="trading-back-to-sara"
          onClick={() => navigate("/")}
          className="fixed bottom-4 right-4 z-10 flex items-center gap-1.5 rounded-full border border-white/20 bg-black/60 px-3.5 py-2 text-[12px] font-semibold text-white backdrop-blur-md hover:bg-black/80 shadow-[0_8px_24px_rgba(0,0,0,0.6)]"
        >
          <ArrowLeft className="h-4 w-4" /> Sara
        </button>
      </div>
    </AppShell>
  );
}
